import { Box, Typography } from '@mui/material';
import { Dispatch } from 'react';
import fileSvg from '../../../../../../../../assets/file.svg';
import {
  CompleteOperationType,
  StartOperationType,
} from '../../../../../../../../model/alerts.model';
import { ModalAction } from '../../../../../../../../model/modal.model';
import zeplinColor from '../../../../../../../../theme/Color';
import CustomButton from '../../../../../../../shared/CustomButton/CustomButton';
import { DragDropModal } from '../DragDropModal';
import styles from './NoDocuments.module.css';

export function NoDocuments({
  fetchDocuments,
  startOperation,
  completeOperation,
  modalDispatch,
  isModalOpen,
}: {
  fetchDocuments: () => Promise<void>;
  startOperation: StartOperationType;
  completeOperation: CompleteOperationType;
  isModalOpen: boolean;
  modalDispatch: Dispatch<ModalAction>;
}) {
  return (
    <section className={styles.container}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          maxWidth: '275px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '48px',
              height: '48px',
              marginBottom: '16px',
            }}
          >
            <img src={fileSvg} className={styles.fileIcon} alt='no contacts icon' />
          </Box>
          <Typography
            sx={{ marginBottom: '8px' }}
            variant='responsiveHeading3'
            color={zeplinColor.BasicBlack}
          >
            No Files Yet
          </Typography>
          <Typography
            sx={{ marginBottom: '20px' }}
            variant='responsiveBody3'
            color={zeplinColor.Neutral8}
          >
            Add client documents to view and manage them here.
          </Typography>
        </Box>
        <CustomButton
          disabled={false}
          onClick={() => modalDispatch({ type: 'OPEN', payload: 'upload' })}
          variant='contained'
          color={'primary'}
          buttonVariant='responsiveButtonMedium'
          style={{
            borderRadius: { xs: '10px', xl: '14px' },
            height: { xs: '32px', xl: '48px' },
            padding: { xs: '7px 12px', xl: '14px 24px' },
            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
          textStyle={{ color: zeplinColor.Neutral1 }}
          text={'Add File'}
          icon={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: ' 20px',
                height: '20px',
              }}
            >
              <img src={`/assets/add-white.svg`} alt='plus icon' />
            </Box>
          }
        />
      </Box>
      <DragDropModal
        isModalOpen={isModalOpen}
        modalDispatch={modalDispatch}
        startOperation={startOperation}
        fetchDocuments={fetchDocuments}
        completeOperation={completeOperation}
      />
    </section>
  );
}
